import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import get from 'lodash/get';
import AccountStore from 'stores/Model/Account/AccountStore';
import constants from 'Constants';
import * as moneyUtils from 'utils/Money';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class OfferStore {

  @setter @observable id;
  @setter @observable account;
  @setter @observable plan;
  @setter @observable customPrice;


  static create(data={}) {
    const instance = new OfferStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "id": null,
      "account": new AccountStore(),
      "plan": "",
      "customPrice": "",
    };
  }

  constructor(defaults=OfferStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=OfferStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "id"},
      {"field": "account", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": AccountStore},
      {"field": "plan"},
      {"field": "customPrice", "accessor": "custom_price"},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get planOption() {
    return constants.PLAN_OPTIONS.filter((row) => row.value === this.plan)[0];
  }

  @computed get price() {
    const option = this.planOption;
    if (option) return option.price;
    return;
  }

  @computed get planName() {
    const option = this.planOption;
    if (option) return option.label;
    return "";
  }

  @computed get planNameWithPrice() {
    if (!this.planName) return "";
    if (this.customPrice) return `${this.planName} (Custom ${moneyUtils.formatAmountDisplay(this.customPrice)}/mo)`;
    return `${this.planName} (${moneyUtils.formatAmountDisplay(this.price)}/mo)`;
  }
}


export default OfferStore;

